<div 
  class="group-card"
  (click)="goToGroup()"
  [ngClass]="{
    'group-card--prime': primeOffer(),
    'group-card--highlights': highlighted,
    'group-card--suggest-half': suggestedHalf,
    'group-card--suggest-full': suggestedFull,
    'card-ftd__group-card': !isHome
  }"
>
  <div class="add-button add-information__add-button">
    <a class="add-information__add-button-link add-button__link" [routerLink]="[urlGo]">
      <img
        src="/assets/svg/arrow-right-white.svg"
        class="add-button__arrow-right"
        [class.add-button__arrow-right--home]="!isHome"
        alt="Ir a la página del grupo"
      />
    </a>
  </div>

  <app-product-image
    class="group-image"
    [product]="product"
    [isHome]="isHome"
    [browser]="browser"
    [lazyLoaded]="lazyLoaded"
    [isFavorite]="isFavorite"
    [group]="groupType"
    [isHalf]="columnHalf"
  ></app-product-image>

  <app-button
    *ngIf="!isHome && !isOffer"
    class="button-see-more"
    [buttonId]="idPrefix + product.id + '-group-redirect'"
    [customClasses]="'xlg main'"
    [class.mini]="isMini"
    [class.app-button__home-r]="isHome"
    [title]="'Ver más'"
    (click)="goToGroup()"
  ></app-button>
</div>